import { Col } from 'antd'
import React from 'react'

function ColStat({ children, span = 12, onClick = () => '' }) {
  return (
    <span onClick={onClick}>
      {' '}
      <Col span={span}>{children}</Col>
    </span>
  )
}

export default ColStat
